import $ from 'jquery';
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import session from '@/models/v5/session';
import template from '@/../templates/mfa/mfa-login.hbs';

var globalCh = Radio.channel('global');

export default Marionette.View.extend({
    template: Handlebars.compile(template),
    ui: {
        totp_code: '#mfa-token',
        mfaButton: '#login-mfa',
    },
    events: {
        'submit #login_form': 'verify_mfa',
    },
    initialize: function (options) {
        this.next = options.next;
    },
    templateContext: function () {
        var app_features = globalCh.request('app_options', 'features');
        var data = {};

        if (app_features && app_features.environment_name) {
            data.env_name = app_features.environment_name;
        }
        data.powered_by = app_features && app_features.powered_by;
        // This is intentionally structured to show signup by default if not overriden
        if (app_features && app_features.signup === false) {
            data.hideSignup = true;
        }
        return data;
    },
    onAttach: function () {
        // Focus mfa token field
        this.ui.totp_code.focus();
    },
    showInputError: function (field, error) {
        field.siblings('.help-block').text(error);
        field.parent().addClass('has-error');
    },
    hideInputError: function (field) {
        // Hack to allow passing an event argument
        if (field.target) field = $(field.target);
        field.siblings('.help-block').text('');
        field.parent().removeClass('has-error');
    },
    verify_mfa: function (e) {
        e.preventDefault();
        e.stopPropagation();
        
        var self = this;

        function go_to_next_page() {
            window.location = self.next;
        }

        function on_login_error(response) {
            var message = response.responseJSON.errors[0].detail;

            Radio.request(
                'alerts',
                'showAlert', {
                    header: 'Error',
                    message: message,
                    messageType: 'danger'
                }
            );
        }

        var totp = this.ui.totp_code.val();

        var login_token = this.getOption('token');

        session.mfa_login(totp, login_token)
            .done(go_to_next_page)
            .fail(on_login_error);
    },
    accept_cookies: function (e) {
        this.ui.cookie_bar.hide();
    }
});


